import { useEffect, useContext, useState } from "react";
import CountryFilter, { ShowPrice } from "../../components/CountryFilter";
import { Context } from "../../components/Context";
import { ASSET_ENDPOINT, ENCRYPTED_KEY, ENDPOINT, fetchData, GET_CHECKOUT_PRODUCT, GET_STRIPE_SECRET } from "../../components/Service";
import UserInfoCard from "./UserInfoCard";
import { format } from "date-fns";
import { decodedText, noImageHandle, showAlertMsg } from "../../components/CommonMethod";
import { useLocation } from "react-router-dom";
import queryString from 'query-string'
import ErrorPage from "../Page/ErrorPage";
import { CheckoutProvider, Elements, EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";
import CustomCheckout from "./CustomCheckout";
import IntentCheckout from "./IntentCheckout";
import { lowerCase, round } from "lodash";

const appearance = {
    theme: 'stripe',
};

const CartBottomIntro = [
    {
        title: 'What you get',
        features: [
            'Fully custom interactive study guide',
            'Timed chemistry exams',
            'Short, to the point videos',
            'Unlimited practise questions',
            '2 year license with guaranteed updates'
        ]
    },
    {
        title: 'So you can',
        features: [
            'Boost your grades',
            'Walk into exams with confidence',
            'Save time to allow studying for other subjects',
            'Set yourself up for success after school'
        ]
    }
];

function DirectCheckout() {
    window.document.title = "Checkout";

    const location = useLocation()
    const [CHECKOUT_TYPE, SET_CHECKOUT_TYPE] = useState('custom'); // custom,embedded,intent
    const [viewCheckoutForm, setViewCheckoutForm] = useState(false);
    const [currencyData, setCurrencyData] = useState({ currency_price: 1.00, currency_type: "AUD", id: 1 });
    const [product, setProduct] = useState(null);
    const [invalidUrl, setInvalidUrl] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({
        id: null,
        biller_first_name: '',
        biller_last_name: '',
        biller_email: '',
        under_18: false,
        accept_terms: false,
    })
    const [context] = useContext(Context);
    const [clientSecret, setClientSecret] = useState(null);
    const [stripePromise, setStripePromise] = useState(null);

    useEffect(() => {
        if (context && context.auth) {
            setUser({
                id: context.auth.id,
                biller_first_name: context.auth.age_group === 1 && context.auth.guardian_details ? context.auth.guardian_details.first_name : context.auth.first_name,
                biller_last_name: context.auth.age_group === 1 && context.auth.guardian_details ? context.auth.guardian_details.last_name : context.auth.last_name,
                biller_email: context.auth.email,
                under_18: false,
                accept_terms: false,
            })

        }
    }, [context])

    useEffect(() => {
        try {
            let query = queryString.parse(location.search)
            const listing_id = decodedText(query?.checkout_id, ENCRYPTED_KEY);
            fetchData(`${GET_CHECKOUT_PRODUCT}/${listing_id}`, 'GET', '', false, false, (res) => {
                if (res.records?.shop_listing_id) {
                    const total_amount = (parseFloat(res.records.tax_rate) + parseFloat(res.records.price));
                    setProduct({ ...res.records, total_amount: total_amount });
                } else {
                    setInvalidUrl(true);
                }
            });
        } catch (error) {
            setInvalidUrl(true);
            // showAlertMsg({error: 'Invaid Url'});
        }
    }, [location])

    const goToModule = async (section) => {
        if (section && !(clientSecret && stripePromise)) {
            const payload = {
                ui_type: CHECKOUT_TYPE,
                currency: lowerCase(currencyData.currency_type),
                pay_amount: round(parseFloat((currencyData.currency_price || 1) * product.total_amount).toFixed(2)),
                amount: round(parseFloat((currencyData.currency_price || 1) * product.price).toFixed(2)),
                tax_amount: round(parseFloat((currencyData.currency_price || 1) * product.tax_rate).toFixed(2)),
                tax_name: product.tax_name,
                product_name: product.title,
                product_image: product.image || 'images/ionic-purple.jpg',
                aud_price: product.total_amount,
                shop_listing_id: product.shop_listing_id,
                user: user,
                user_id: user.id,
            }
            const request = { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) };
            setLoading(true);
            const stripeSecretResponse = await fetch(`${ENDPOINT}${GET_STRIPE_SECRET}`, request).then(res => res.json());
            setLoading(false);
            if (!stripeSecretResponse?.stripeClientSecret) {
                showAlertMsg({ error: stripeSecretResponse?.error || 'Opps something went wrong' });
            } else {
                setViewCheckoutForm(section);
                const stripeKey = decodedText(stripeSecretResponse?.stripeClientKey, ENCRYPTED_KEY);
                setStripePromise(loadStripe(stripeKey));
                setClientSecret(stripeSecretResponse?.stripeClientSecret);
            }
        } else {
            setViewCheckoutForm(section);
            setStripePromise(null);
            setClientSecret(null);
        }
    }





    if (invalidUrl) return <ErrorPage />

    return (<>
        <section className="py-5">
            <div className="container container-1180">
                <div className="row">
                    <CountryFilter disabled={viewCheckoutForm} title="Checkout" currencyData={currencyData} setCurrencyData={setCurrencyData} />
                    {/* <div className="col-md-6  pt-2 d-none1">
                        <div className="form-floating">
                            <select disabled={viewCheckoutForm} className="form-select form-select-md" onChange={(e) => SET_CHECKOUT_TYPE(e.target.value)}>
                                <option value="custom">custom</option>
                                <option value="embedded">embedded</option>
                                <option value="intent">intent</option>
                            </select>
                        </div>
                    </div> */}
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-lg-6 col-sm-12 col-md-12">
                                <div className="row">
                                    <div className="col-sm-12 newpage">
                                        {user && <>
                                            <UserInfoCard data={user} setData={setUser} show={!viewCheckoutForm} goto={goToModule} loading={loading} />
                                            <div className="rounded-2 border border-2 border-blue p-4 my-2">
                                                <div className="col-sm-12 d-flex">
                                                    <div className="account d-flex ">
                                                        <h4 className=" rounded-circle border border-blue text-blue fs-24 px-2 ">2</h4><h4 className=" fw-bold fs-24  text-blue ms-2">Payment</h4>
                                                    </div>
                                                </div>
                                                {viewCheckoutForm && <>
                                                    <div className="row py-2">
                                                        <div className="col-sm-12">
                                                            <p className="fw-bold"> Pay by</p>
                                                            {(clientSecret && stripePromise) && <>
                                                                {CHECKOUT_TYPE === 'custom' && <>
                                                                    <CheckoutProvider stripe={stripePromise} options={{ fetchClientSecret: () => clientSecret, elementsOptions: { appearance } }}>
                                                                        <CustomCheckout />
                                                                    </CheckoutProvider>
                                                                </>}
                                                                {CHECKOUT_TYPE === 'embedded' && <>
                                                                    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ fetchClientSecret: () => clientSecret }}>
                                                                        <EmbeddedCheckout />
                                                                    </EmbeddedCheckoutProvider>
                                                                </>}
                                                                {CHECKOUT_TYPE === 'intent' && <>
                                                                    <Elements stripe={stripePromise} options={{ clientSecret }}>
                                                                        <IntentCheckout />
                                                                    </Elements>
                                                                </>}
                                                            </>}
                                                        </div>
                                                    </div>
                                                </>}
                                            </div>
                                        </>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-12 col-md-12">
                                <div className="d-flex justify-content-between pt-3 pb-2 px-2 mx-2">
                                    <h4 className="fs-24 fw-bold ">Your cart </h4>
                                    <h4 className="fs-24 fw-bold">{product ? 1 : 0} item</h4>
                                </div>

                                {product && <>
                                    <div className="d-sm-flex d-block justify-content-between pb-5">
                                        <div className="d-flex ">
                                            <img src={product.image ? ASSET_ENDPOINT + product.image : '../images/ionic-purple.jpg'} className="img-fluid border mmwh-180 mb-2 h-100 me-2" alt={product.title} onError={noImageHandle} />
                                            <div>
                                                <p className="fw-bold">{product.title}</p>
                                                <span className="bg-purple text-white fw-bold text-uppercase rounded-pill px-3 py-2 me-2">{product.course_abbr}</span>
                                                <h6 className="mt-3 text-green bold">{(product.cart_updated && product.cart_updated !== '0') && `This item has been updated on ${format(new Date(product.cart_updated), 'MM/dd/yyyy')}.`}</h6>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div className="col-sm-12 px-3">
                                                <div className="row gap-0">
                                                    <div className="col">
                                                        <p className="fw-bold">Price</p>
                                                    </div>
                                                    <div className="col text-nowrap">
                                                        <p className="fw-bold text-end"><ShowPrice currencyData={currencyData} price={product.price} /></p>
                                                    </div>
                                                </div>
                                                {product.tax_name && <>
                                                    <div className="row gap-0">
                                                        <div className="col">
                                                            <p className="fw-bold text-nowrap">{`${product.tax_name}(${product.tax_percentage}%)`}</p>
                                                        </div>
                                                        <div className="col text-nowrap">
                                                            <p className="fw-bold text-end"><ShowPrice currencyData={currencyData} price={product.tax_rate} /></p>
                                                        </div>
                                                    </div>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                </>}

                                <div className="d-flex justify-content-end py-3" style={{ borderTop: '2px solid black' }}>
                                    <div className="col">
                                        <p className="fw-bold fs-24">Total
                                            <span className="float-end"><ShowPrice currencyData={currencyData} price={product ? product.total_amount : 0} /></span>
                                        </p>
                                    </div>
                                </div>

                                <div className="rounded-2 border border-2 bg-light border-gray p-4 my-3">
                                    {CartBottomIntro.map((item, index) => {
                                        return <div key={index} className={index > 0 ? 'mt-4' : ''}>
                                            <h4 className="fw-bold fs-20">{item.title}</h4>
                                            <ul className="ps-4 mb-0">
                                                {item.features && item.features?.map((text, i) => <li key={i}>{text}</li>)}
                                            </ul>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>)
}
export default DirectCheckout
